import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import store from 'software_renewal/redux/store';
import ProductDescription from 'software_renewal/ProductDescription';
import Cart from 'software_renewal/Cart';
import ToasterComponent from 'shared/components/ToasterComponent';

document.addEventListener('DOMContentLoaded', () => {
  const productDescriptionContainer = document.getElementById('product-description');
  const cartContainer = document.getElementById('cart');

  if (cartContainer != null) {
    render(
      <Provider store={store}>
        <ToasterComponent />
        <Cart />
      </Provider>,
      cartContainer,
    );
  }

  if (productDescriptionContainer != null) {
    render(
      <Provider store={store}>
        <ProductDescription />
      </Provider>,
      productDescriptionContainer,
    );
  }
});
